// extracted by mini-css-extract-plugin
export default {"main-container":"MainContainer_main-container__NZ5P7"};